import { render } from "./organization-documents.vue?vue&type=template&id=4dc6d39e"
import script from "./organization-documents.vue?vue&type=script&lang=js"
export * from "./organization-documents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__